import { useMemo } from 'react';

import { useDocument } from '../../../../../../api/documents';
import { getDocumentIncludesForRelationshipObject } from '../../../../../../utils/queries';
import { useTenantedApplicationConfig } from '../../../../../tenantedApplicationConfig';
import { sortDocumentRelationships } from './logic/sortDocumentRelationships';

export const useWorkflowRootDocument = (
  documentId: string,
  workflowName: string,
  place: string | undefined,
) => {
  const config = useTenantedApplicationConfig();

  const workflowConfig = workflowName
    ? config.getWorkflowConfig(workflowName)
    : undefined;
  const definitionName = workflowConfig?.rootDocument.definition ?? '';
  const includes = workflowConfig
    ? getDocumentIncludesForRelationshipObject(
        workflowConfig.rootDocument.relationships,
      )
    : undefined;

  const { document: documentQueryData, ...rest } = useDocument(
    documentId,
    definitionName,
    includes,
    workflowName,
    {
      enabled: Boolean(documentId) && Boolean(definitionName),
      queryKeySuffix: [place],
    },
  );

  const rootDocument = useMemo(() => {
    if (!documentQueryData || !workflowConfig) return undefined;
    return sortDocumentRelationships(
      documentQueryData,
      workflowConfig.rootDocument.relationships,
    );
  }, [documentQueryData, workflowConfig]);

  return { rootDocument, ...rest };
};
